import { render, staticRenderFns } from "./TalkizyConnectActions.vue?vue&type=template&id=66bd64c4&scoped=true&"
import script from "./TalkizyConnectActions.vue?vue&type=script&lang=js&"
export * from "./TalkizyConnectActions.vue?vue&type=script&lang=js&"
import style0 from "./TalkizyConnectActions.vue?vue&type=style&index=0&id=66bd64c4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66bd64c4",
  null
  
)

export default component.exports